import { render, staticRenderFns } from "./ResultsList.vue?vue&type=template&id=3a15960e&scoped=true&"
import script from "./ResultsList.vue?vue&type=script&lang=js&"
export * from "./ResultsList.vue?vue&type=script&lang=js&"
import style0 from "./ResultsList.vue?vue&type=style&index=0&id=3a15960e&lang=scss&scoped=true&"
import style1 from "./ResultsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a15960e",
  null
  
)

export default component.exports